import { defineComponent as _defineComponent } from 'vue';
import Button from 'primevue/button';
import { ref } from 'vue';
import { formatISODate, getEnumKeyByValue } from '@/Services/Utils';
import { FormPanel, Salinity } from '../../../@types/Enums';
import { trans } from 'laravel-vue-i18n';
import { useRoute } from '../../../Plugins/ziggy';
import { useMitt } from '../../../Plugins/mitt';
import DetailValue from '../../../Components/DetailValue.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'Details',
    props: {
        data: {
            type: Object,
            required: true,
        },
    },
    setup(__props, { expose }) {
        expose();
        const props = __props;
        const route = useRoute();
        const emitter = useMitt();
        const localData = ref(props.data);
        const edit = () => {
            emitter.emit('open-form-panel-enum', {
                form: FormPanel.IrrigationWaterData,
                data: localData.value,
            });
        };
        emitter.on('irrigation-water-data-saved', (data) => {
            localData.value = data;
        });
        const __returned__ = { route, emitter, props, localData, edit, get Button() { return Button; }, get formatISODate() { return formatISODate; }, get getEnumKeyByValue() { return getEnumKeyByValue; }, get Salinity() { return Salinity; }, get trans() { return trans; }, DetailValue };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
